// extracted by mini-css-extract-plugin
module.exports = {"iosConfirm":"confirm_iosConfirm__c8zSz","buttons":"confirm_buttons__HdGiH","iosBtns":"confirm_iosBtns__da3Py","btn":"confirm_btn__amI4t"};